import type { ApiServices } from "$src/core/contexts/api";
import type { TranslationKey } from "$src/core/models/translation";

/** Injection seam for the car tasks: they run outside the React tree, so no hooks. Published in `index.car.ts`. */

export type CarRuntime = {
  api: ApiServices;
  translate: (key: TranslationKey) => string;
};

let runtime: CarRuntime | null = null;
const readyListeners = new Set<() => void>();

export const setCarRuntime = (next: CarRuntime): void => {
  const wasMissing = runtime === null;
  runtime = next;
  // Serve car surfaces that connected before the runtime existed.
  if (wasMissing) {
    const listeners = [...readyListeners];
    readyListeners.clear();
    listeners.forEach((listener) => listener());
  }
};

export const getCarRuntime = (): CarRuntime | null => runtime;

/** Runs `listener` once the runtime exists — immediately if it already does. */
export const onCarRuntimeReady = (listener: () => void): void => {
  if (runtime) {
    listener();
    return;
  }
  readyListeners.add(listener);
};

// Lets tasks suppress toasts on headless runs; they would queue and pop up later.
let carUiMounted = false;

export const setCarUiMounted = (mounted: boolean): void => {
  carUiMounted = mounted;
};

export const isCarUiMounted = (): boolean => carUiMounted;
